import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Box,
  Typography,
  Dialog,
  IconButton,
  DialogContent,
  Button,
} from "@mui/material";
import { LOGOUT_START } from "Actions/AuthAction";
import { makeStyles } from "@mui/styles";
import { START_GET_REFRESHTOKEN } from "Actions/UserAction";
import { ReactComponent as CloseIcon } from "../../Assets/Icons/CloseIcon.svg";
import TimerIcon from "@mui/icons-material/Timer";

const useStyle = makeStyles((theme) => ({
  rsDialog: {
    "& .MuiDialog-container": {
      "& .MuiPaper-root": {
        // borderRadius: "20px !important",
        borderRadius: "32px !important",
        maxWidth: "620px",
        // height: "556px",
        padding: "10px 0px",
        "@media (max-height: 800px)": {
          top: "10px !important",
        },
      },
    },
  },
  ModalHeading: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-end",
    padding: "0px 10px",
  },
  closeIconBtn: {
    "&>button": {
      padding: "0px",
    },
    "&>svg": {
      width: "17px",
      height: "17px",
      [theme.breakpoints.down(769)]: {
        width: "15px",
        height: "15px",
      },
      [theme.breakpoints.down(359)]: {
        width: "12px",
        height: "12px",
      },
    },
  },
  timer: {
    height: "100px !important",
    width: "100px !important",
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "top",
    alignItems: "center",
    padding: "0 1rem !important",
    "&>h3, &>p": {
      textAlign: "center",
      padding: "1rem",
    },
    "&>svg": {
      fill: "#e54c42 !important",
    },
  },
  logOut: {
    color: "black !important",
    textDecoration: "underline",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "1.1rem !important",
  },
  countdownTimer: {
    fontSize: "2.3rem !important",
    color: "black !important",
    fontWeight: "500 !important",
  },
}));

const TimerLogoutDailog = (props) => {
  const {
    open,
    setOpen,
    remainingTime,
    logout,
    getRefreshTokenAction,
    triggerIdleAcrossTabs
  } = props;
  const classes = useStyle();
  // const [countdown, setCountdown] = useState(5); // 5 secs
  const [countdown, setCountdown] = useState(300); // 5 minutes = > 300 secs

  const channel = new BroadcastChannel("countdown_channel"); // Channel name for communication

  const handleClose = () => {
    setOpen(false);
    getRefreshTokenAction(); // refresh token for Close dialog and User is Active
    localStorage.setItem(
      "LastDailogAt",
      JSON.stringify({
        time: Date.now(),
        place: "dailog",
        action: "close",
      })
    );
    channel.postMessage("closed");
  };

  useEffect(() => {
    if (!open) {
      channel.postMessage("closed");
      return;
    }

    const updateCountdown = () => {
      setCountdown((prevCountdown) => {
        const newCountdown = prevCountdown - 1;

        // Broadcast the new countdown value to other tabs
        channel.postMessage(newCountdown);
        if (newCountdown <= 0) {
          clearInterval(interval);
          triggerIdleAcrossTabs();
          channel.close();
          return 0;
        }
        return newCountdown;
      });
    };
    
    const interval = setInterval(updateCountdown, 1000);

    const handleMessage = (event) => {
      if (event.data === "closed") {
        setOpen(false);
      }
      if (event.data !== countdown) {
        setCountdown(event.data);
      }
    };

    channel.addEventListener("message", handleMessage);

    return () => {
      clearInterval(interval);
      channel.removeEventListener("message", handleMessage);
    };
  }, [open, countdown, channel]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, "0")}`;
  };

  const handleLogout = () => {
    localStorage.setItem("LogOutFromButton", JSON.stringify(true));
    triggerIdleAcrossTabs();
    // logout();
  };

  return (
    <Dialog
      className={classes.rsDialog}
      maxWidth={"xs"}
      open={open}
      onClose={(e) => {
        if (e.key === "Escape") {
          handleClose();
        }
      }}
      BackdropProps={{
        classes: {
          root: "root",
        },
      }}
    >
      <Box className={classes.container}>
        <Box className={classes.ModalHeading}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            className={classes.closeIconBtn}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
      <DialogContent className={classes.dialogContent}>
        <TimerIcon className={classes.timer} />
        <Typography variant="h3" fontWeight={"500"} color={"black"}>
          You're about to be logged Out{" "}
        </Typography>
        <Typography>
          It looks like you're not active right now. To keep your account
          secure, we'll automatically log you out when the timer runs out.{" "}
        </Typography>

        <Typography className={classes.countdownTimer}>
          {formatTime(countdown)}
        </Typography>
        <Box>
          <Button
            className="BtnGreen"
            variant="contained"
            onClick={handleClose}
          >
            Stay logged In
          </Button>
        </Box>
        <Typography className={classes.logOut} onClick={handleLogout}>
          {" "}
          Log out now{" "}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  refreshTokenDetail: state.user.refreshTokenDetail,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch({ type: LOGOUT_START }),
  getRefreshTokenAction: (payload) =>
    dispatch({ type: START_GET_REFRESHTOKEN, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(TimerLogoutDailog);
